<template>
  <div class="font-QuestrialFont">
    <ul class="flex space-x-3">
      <li class="list-item-style" @click="$emit('editClicked')">Edit</li>
      <li class="list-item-style text-red-400" @click="$emit('deleteClicked')">
        Delete
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AdminOptions",
};
</script>

<style scoped>
.list-item-style {
  @apply px-4 py-2 hover:bg-gray-100 border rounded cursor-pointer;
}
</style>

